"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogoLoader_1 = require("./LogoLoader");
exports.default = LogoLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/components/LogoLoader/index.js
// module id = 1203
// module chunks = 8